import { ScrollToPlugin, CSSPlugin } from 'gsap/all';

export const GSAP_PLUGINS = { ScrollToPlugin, CSSPlugin };
